import React from 'react'
import moment from 'moment'
import { Icon } from 'Components'
import { ObjectiveTitle, ObjectiveSubtitle, DraftSpan, IconTag } from './shared'
import { colors, colorTypeMap, iconTypeMap } from 'Utils'
import { CheckOutlined, CloseOutlined, ClockCircleOutlined,  } from '@ant-design/icons'

const sixMonths = moment().subtract(6, 'months').unix() * 1000;

export const CollapseHeader = ({ title, date, date2, estado, medida, isDistributor = false, isActive }) => (

  <>
    <div>
      {medida && <IconTag borderColor={colorTypeMap[medida.id]}> < Icon type={iconTypeMap[medida.id]} size={24} /></IconTag>}
      {(estado && estado === "Draft") && <IconTag borderColor={colors.redCruz} style={{ marginLeft: -5 }} > <Icon type="contract" size={24} /></IconTag>}
      <ObjectiveTitle>{(estado && estado === "Draft") && <DraftSpan> [ BORRADOR ] </DraftSpan>}{title} </ObjectiveTitle>
      { isDistributor && (
        !isActive ? (
          <span style={{ marginLeft: 5, fontSize: 13, display: 'inline-block'}}>
            <CloseOutlined style={{ color: colors.redCruz, fontSize: "17px" }} />
            <span style={{ marginLeft: 2 }}>Desactivado</span>
          </span>
        ) : (
          date2 && sixMonths > date2 ? (
            <span style={{ marginLeft: 5, fontSize: 13, display: 'inline-block'}}>
              <ClockCircleOutlined style={{ color: colors.trueYellow, fontSize: "17px" }} />
              <span style={{ marginLeft: 2 }}>A revisar</span>
            </span>
          ) :(
            <span style={{ marginLeft: 5, fontSize: 13, display: 'inline-block'}}>
              <CheckOutlined style={{ color: colors.trueGreen, fontSize: "17px" }} />
              <span style={{ marginLeft: 2 }}>Activo</span>
            </span>
          )
        )
      )}
    </div>

    <ObjectiveSubtitle>
      Editado por última vez, {moment(date).calendar(null, formatOptions)}
    </ObjectiveSubtitle>

    {isDistributor && (
      <ObjectiveSubtitle>
      Última conexión: {(date2 && date2 !== -62135596800000 )? moment(date2).calendar(null, formatOptions) : 'Nunca'}
    </ObjectiveSubtitle>
    )}


  </>
)

export const formatOptions = {
  sameDay: '[Hoy, ]h:mm a',
  lastDay: '[Ayer, ]h:mm a',
  lastWeek: 'D [de] MMM [de] YYYY [a las] h:mm a',
  sameElse: 'D [de] MMM [de] YYYY [a las] h:mm a',
}
